import { apiRequest } from '@/utils/api-request';

export const signOut = async () => {
  const response = await apiRequest({
    url: '/user/sign-out',
    method: 'POST',
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to sign out' };
  }

  return response;
};
